export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20art%20with%20geometric%20crystalline%20shapes%20in%20warm%20amber%20and%20deep%20teal%20tones%2C%20smooth%20gradients%2C%20modern%20minimal%20gaming%20aesthetic%2C%20clean%20matte%20finish%2C%20particle%20like%20floating%20elements%2C%20elegant%20dark%20background%20with%20subtle%20warm%20light%20streaks%2C%20no%20text%2C%20abstract%20composition%20perfect%20for%20hero%20section%20backdrop%2C%208k%20quality%20render&width=1800&height=1200&seq=coreloop-hero-bg&orientation=landscape"
          alt="Coreloop Partners Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm font-medium text-background-50/90">Turkey&apos;s Game Industry Consultancy</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-background-50 leading-tight mb-6">
          Take Your Game Studio<br />
          <span style={{ color: 'oklch(var(--primary-400))' }}>to the Next Level</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          Expert guidance in game design, art direction, and business development. We partner with studios to unlock their full potential.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#services"
            className="w-full sm:w-auto text-sm md:text-base font-semibold px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Our Services
          </a>
          <a
            href="#contact"
            className="w-full sm:w-auto text-sm md:text-base font-semibold px-8 py-3.5 rounded-lg border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get in Touch
          </a>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 md:gap-12">
          {[
            { value: '50+', label: 'Game Studios' },
            { value: '10+', label: 'Years Experience' },
            { value: '3', label: 'Expert Consultants' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#services" className="w-10 h-10 flex items-center justify-center text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
          <i className="ri-arrow-down-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}